/* <mb-incentive-bar> — keeps the incentive bar stuck precisely under the
   sticky header by measuring the header section's live height and writing
   it onto the wrapper as --mb-header-h. ResizeObserver covers logo-size
   changes from the theme editor and the mobile/desktop padding swap. */

class MbIncentiveBar extends HTMLElement {
  #ro;
  #header;
  #wrap;

  connectedCallback() {
    this.#header = document.querySelector('.modern-section--header');
    this.#wrap = this.closest('.modern-section--incentive-bar');
    if (!this.#header || !this.#wrap) return;
    this.#measure();
    this.#ro = new ResizeObserver(() => this.#measure());
    this.#ro.observe(this.#header);
  }

  disconnectedCallback() {
    this.#ro?.disconnect();
  }

  #measure = () => {
    this.#wrap.style.setProperty('--mb-header-h', `${this.#header.offsetHeight}px`);
  };
}

customElements.define('mb-incentive-bar', MbIncentiveBar);
